import { render, staticRenderFns } from "./SvgCommerceCategory.vue?vue&type=template&id=16e32eaf&scoped=true"
import script from "./SvgCommerceCategory.vue?vue&type=script&lang=js"
export * from "./SvgCommerceCategory.vue?vue&type=script&lang=js"
import style0 from "./SvgCommerceCategory.vue?vue&type=style&index=0&id=16e32eaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e32eaf",
  null
  
)

export default component.exports